/**
 * @generated SignedSource<<49e791ce4d08b764fe6596cbd4e087ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type analyticsListener_content$data = {
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "analyticsListener_content";
};
export type analyticsListener_content$key = {
  readonly " $data"?: analyticsListener_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"analyticsListener_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "analyticsListener_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "subType"
    }
  ],
  "type": "Content"
};

(node as any).hash = "3ce317f8b2b631328fc2f59238836550";

export default node;
